/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { UPDATE_ROLES } from "../graphql";
import { pretty } from "@vlinder-web/utils-react";

export interface IUpdateRolesMethods extends IPluginMethodMap {
  getUpdateRolesProps(args: any): Promise<any>;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class UpdateRolesService implements IAgentPlugin {
  readonly methods: IUpdateRolesMethods;

  constructor() {
    this.methods = {
      getUpdateRolesProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("args==>",pretty(args))
    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_ROLES,
          variables:{
            input: {
              role: args?.roleId,
              vuid: args?.userId
            }
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          console.log(`roles update data`, res.data);
          return {
            data: res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
